export default function ErrorIcon(props: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.999"
      height="21.405"
      className={props.className}
    >
      <path
        d="m.429 16.706 8.83-15.14a3.181 3.181 0 0 1 5.482 0l8.83 15.14a3.133 3.133 0 0 1-2.741 4.7H3.17a3.133 3.133 0 0 1-2.741-4.7z"
        fill="#d52a23"
      />
      <path
        d="M13.174 18.248A1.174 1.174 0 1 1 12 17.074a1.173 1.173 0 0 1 1.174 1.174zM12 15.821a1.14 1.14 0 0 0 1.137-1.07l.539-8.93a1.139 1.139 0 0 0-1.137-1.208h-1.078a1.139 1.139 0 0 0-1.137 1.208l.539 8.93A1.14 1.14 0 0 0 12 15.821z"
        fill="#fff"
      />
    </svg>
  );
}
